import { ApiPathAskGateway } from '@packages/shared/core/common/constants/apiPaths';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { isNonEmptyString } from '@packages/shared/core/common/utils/isNonEmptyString';
import { parseQueryParams } from '@packages/shared/core/common/utils/query';
import { HttpClient } from '@packages/shared/core/common/services';
import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { UserLocation } from '../entities';
import { LocationServiceDependencies } from '../entities/LocationServiceDependencies';
import { LocationService } from './LocationService';

export class LocationClientService implements LocationService {
  private readonly httpClient: HttpClient;

  private logger: Logger;

  private askGatewayHttpClient: HttpClient;

  private overriddenValues: Partial<UserLocation> = {};

  constructor({ httpClient, askGatewayHttpClient, logger }: LocationServiceDependencies) {
    this.httpClient = httpClient;
    this.askGatewayHttpClient = askGatewayHttpClient;
    this.logger = logger;
    this.loadFormQueryParams();
  }

  async getLocation(): Promise<UserLocation> {
    try {
      const { data } = await this.askGatewayHttpClient.get(ApiPathAskGateway.LOCALE);

      return {
        region: isNonEmptyString(this.overriddenValues.region) ? this.overriddenValues.region : data.region,
        country: isNonEmptyString(this.overriddenValues.country) ? this.overriddenValues.country : data.country,
        locale: data.locale ?? data.language,
        currency: data.currency,
        currencySymbol: data.currencySymbol,
      };
    } catch (err) {
      const error = normalizeError(err);
      this.logger.error(error);

      return {};
    }
  }

  private loadFormQueryParams() {
    const queries = parseQueryParams() as Partial<UserLocation>;

    this.overriddenValues.region = queries.region;
    this.overriddenValues.country = queries.country;
  }
}
